import { useMemo } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from 'src/modules/auth';

export default function ChallengeRoute() {
    const { challenge } = useAuth();

    return useMemo(() => (challenge ? <Outlet /> : <Navigate to={'/login'} />), [challenge]);
}
